// ============================================================================
// appBadges.ts — БЕЙДЖИ ПРИЛОЖЕНИЙ в доке (SSoT/SRP). Приложение ставит/снимает
// бейдж через sdk.notify.badge(code,count); док-панель (AppDock) читает стора
// и показывает бейдж на иконке приложения. Владелец счётчика — приложение,
// источник — зовет ядро (sdk), но сам UI дока — единый.
// Чат (системное приложение) использует свой unread-механизм ядра; общий путь
// тот же: приложение пишет badge, док показывает.
// ============================================================================

import { create } from 'zustand';

interface AppBadgesState {
  /** appCode → счётчик (0 — скрыть бейдж) */
  badges: Record<string, number>;
  setBadge: (appCode: string, count: number) => void;
  badgeOf: (appCode: string) => number;
}

export const useAppBadgesStore = create<AppBadgesState>((set, get) => ({
  badges: {},
  setBadge: (appCode, count) => {
    const countN = Math.max(0, Math.trunc(Number(count) || 0));
    const prev = get().badges;
    if (countN === 0) {
      if (prev[appCode] === undefined) return;
      const next = { ...prev };
      delete next[appCode];
      set({ badges: next });
      return;
    }
    if (prev[appCode] === countN) return;
    set({ badges: { ...prev, [appCode]: countN } });
  },
  badgeOf: (appCode) => get().badges[appCode] || 0,
}));
